export default __webpack_public_path__ + "static/media/airdockz-blk-3.d083e954.png";